import Button, { ButtonColorTypes } from "../shared-components/Button";
import AddNoteIcon from "../shared-components/icons/AddNoteIcon";
import TextAreaField from "../shared-components/TextAreaField";

type Props = {
  note: string;
  onChange?: ({ target }: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onCancel?: () => void;
  onSubmit?: () => void;
};

const AddNoteModal = ({ onChange, onCancel, onSubmit, note }: Props) => {
  return (
    <div className="flex p-6">
      <div>
        <div className="bg-green-100 rounded-3xl mr-4">
          <AddNoteIcon />
        </div>
      </div>
      <div className="w-full flex flex-col">
        <div className="text-lg leading-6 font-medium">Add Note</div>

        <div className="text-sm w-full	py-3 leading-5 font-medium mb">
          <TextAreaField
            onChange={onChange}
            name={"note input"}
            placeholder="Write here..."
            className={`pb-20 mb-4 w-full ${
              note.length > 255 ? "focus:border-red-700 border-red-700" : ""
            }`}
          />
          <div className="text-xs	 text-gray-400	text-right">{`${note.length}/255 characters`}</div>
          <div className="flex ml-auto w-full	">
            <Button
              text="Cancel"
              colorType={ButtonColorTypes.cancel}
              onClick={onCancel}
              className="h-9	max-h-full w-20 max-w-full mr-3"
            />
            <Button
              text="Add"
              onClick={onSubmit}
              disabled={note.length > 255}
              className="w-24 max-w-full h-9 max-h-full"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddNoteModal;
